import { Dialog, DialogContent, Grid } from '@material-ui/core';
import React, { FunctionComponent, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

import Texto from '@infotrack/presentacion-componentes/texto';
import { manejadorDialogoGlobal } from '@infotrack/presentacion-utilitarios/manejadoresComponentes';

import IDocumentoConsultaGeneral, {
    DOCUMENTO_CONSULTA_GENERAL_POR_DEFECTO,
} from 'Infotrack@Modelos/negocioRefactor/entidades/consulta/IDocumentoConsultaGeneral';
import IDocumentoDetalleConsultaGeneral from 'Infotrack@Modelos/negocioRefactor/entidades/consulta/IDocumentoDetalleConsultaGeneral';
import IDocumento from 'Infotrack@Modelos/negocioRefactor/entidades/repositorio/IDocumento';
import IDocumentoDetalle from 'Infotrack@Modelos/negocioRefactor/entidades/repositorio/IDocumentoDetalle';
import TiposProceso from 'Infotrack@Modelos/negocioRefactor/enumeraciones/TiposProceso';
import IBodega from 'Infotrack@Modelos/smartStock/bodegas/entidades/bodega';
import IBodegaDivisiones from 'Infotrack@Modelos/smartStock/bodegasDivisiones/entidades/bodegasDivisiones';
import IEtapas from 'Infotrack@Modelos/smartStock/etapas/entidades/etapas';
import IItemsConsulta from 'Infotrack@Modelos/smartStock/items/entidades/IItemsConsulta';
import { IEstadoGlobal } from 'Infotrack@Reductores/interfacesReductores';
import DetallesFormulario from 'Infotrack@Transversales/componentes/DetallesFormulario/DetallesFormulario';
import EstadosDetallesFormulario from 'Infotrack@Transversales/componentes/DetallesFormulario/enumeraciones';
import DetallesInventario from 'Infotrack@Transversales/componentes/DetallesInventario/DetallesInventario';
import DocumentoBuscador from 'Infotrack@Transversales/componentes/DocumentoBuscador/DocumentoBuscador';
import DocumentoValorTotal from 'Infotrack@Transversales/componentes/DocumentoValorTotal/DocumentoValorTotal';
import { EstadosFormularioDocumento } from 'Infotrack@Transversales/componentes/FormularioDocumento/enumeraciones';
import FormularioDocumento, {
    IEntidadesFormularioDocumento,
} from 'Infotrack@Transversales/componentes/FormularioDocumento/FormularioDocumento';
import ModalEncabezado from 'Infotrack@Transversales/componentes/ModalEncabezado/ModalEncabezado';
import TablaDetalles from 'Infotrack@Transversales/componentes/TablaDetalles/TablaDetalles';
import TablaDetallesPlantilla from 'Infotrack@Transversales/componentes/TablaDetallesProductos/TablaDetallesPlantilla';

import {
    CAMPOS_DESHABILITAR_DETALLES_FORMULARIO,
    CAMPOS_DESHABILITAR_DOCUMENTO_FORMULARIO,
    CAMPOS_DESHABILITAR_DOCUMENTO_FORMULARIO_EDICION,
    CAMPOS_OCULTAR_DETALLES_FORMULARIO,
    CAMPOS_OCULTAR_DETALLES_TABLA,
    CAMPOS_OCULTAR_DOCUMENTO_FORMULARIO,
    CAMPOS_EDITABLES_DETALLES_INVENTARIO,
    CAMPOS_OCULTAR_DETALLES_INVENTARIO,
    ENTIDADES_DOCUMENTO_POR_DEFECTO,
    CAMPOS_DESHABILITAR_TABLA_INVENTARIO,
} from './constantes';
import EntidadesDetalleCM from './controladorModelo/EntidadesDetalleCM';
import EntidadesDocumentoCM from './controladorModelo/EntidadesDocumentoCM';
import ItemCM from './controladorModelo/ItemCM';
import MovimientoCM from './controladorModelo/MovimientoCM';
import SalidaInventarioCM from './controladorModelo/SalidaInventarioCM';
import { EstadosModalSalidaInventario } from './enumeraciones';
import { estadoActivo } from 'Infotrack@Transversales/constantes/ConstantesEstados';
interface IModalSalidaInventaioProps {
    cerrar: () => void;
    documentoId: string | null;
    establecerDocumentoId: (documentoId: string) => void;
    estado: EstadosModalSalidaInventario;
    descargarDocumentoPdf: (documento: IDocumentoConsultaGeneral) => any;
    cambiarEstado: () => void;
}

const ModalSalidaInventario: FunctionComponent<IModalSalidaInventaioProps> = ({
    cerrar,
    documentoId,
    establecerDocumentoId,
    estado,
    descargarDocumentoPdf,
    cambiarEstado,
}) => {
    const idPerfilResponsable = process.env.REACT_APP_ID_PERFIL_RESPONSABLE!;
    const entidadesDocumentoCM = useMemo(() => new EntidadesDocumentoCM(), []);
    const salidaInventarioCM = useMemo(() => new SalidaInventarioCM(), []);
    const entidadesDetalleCM = useMemo(() => new EntidadesDetalleCM(), []);
    const itemCM = useMemo(() => new ItemCM(), []);
    const movimientoCM = useMemo(() => new MovimientoCM(), []);

    const idEmpresa = useSelector((e: IEstadoGlobal) => e.estadoAutenticacion.usuarioInformacion!.IdEmpresa);
    const idAgencia = useSelector((e: IEstadoGlobal) => e.estadoAutenticacion.agenciaActual!.IdAgencia);
    const idUsuario = useSelector((e: IEstadoGlobal) => e.estadoAutenticacion.usuarioInformacion!.IdUsuario);
    const [items, setItems] = useState<IItemsConsulta[]>([]);
    const [detalleInicialEdicion, setDetalleInicialEdicion] = useState<IDocumentoDetalle | null>(null);
    const [DocumentoDetallesBase, setDocumentoDetallesBase] = useState<IDocumentoDetalleConsultaGeneral[]>([]);
    const [entidadesDocumento, setEntidadesDocumento] = useState<Partial<IEntidadesFormularioDocumento>>(
        ENTIDADES_DOCUMENTO_POR_DEFECTO
    );
    const [documento, setDocumento] = useState<IDocumentoConsultaGeneral | null>(null);
    const [etapasSiguientes, setEtapasSiguientes] = useState<IEtapas[]>([]);
    const [ejecutarConsultarDocumentos, setEjecutarConsultarDocumentos] = useState<boolean>(false);
    const [entidadesDetalle, setEntidadesDetalle] = useState<{
        items: IItemsConsulta[];
        divisionesOrigen: IBodegaDivisiones[];
        bodegasOrigen: IBodega[];
    }>({ items: [], divisionesOrigen: [], bodegasOrigen: [] });
    const [detalles, setDetalles] = useState<IDocumentoDetalleConsultaGeneral[]>([]);

    useEffect(() => {
        alCambiarEstado();
    }, [estado]);

    useEffect(() => {
        if (documento) alEstablecerDocumento();
    }, [documento]);

    useEffect(() => {
        consultarDetalles();
    }, [ejecutarConsultarDocumentos]);

    const alCambiarEstado = async () => {
        if (estado === EstadosModalSalidaInventario.CERRADO) {
            setDocumento(null);
            setDetalles([]);
            setEntidadesDocumento(ENTIDADES_DOCUMENTO_POR_DEFECTO);
            setEtapasSiguientes([]);
            setEntidadesDetalle({ items: [], divisionesOrigen: [], bodegasOrigen: [] });
            setDetalleInicialEdicion(null);
            setDocumentoDetallesBase([]);
        }
        if (estado === EstadosModalSalidaInventario.CREACION) {
            setDocumentoDetallesBase([]);
            await consultarEntidadesDocumento();
        }
        if (estado === EstadosModalSalidaInventario.EDICION || estado === EstadosModalSalidaInventario.VISUALIZACION) {
            await consultarDocumento(documentoId!);
        }
    };

    const consultarEntidadesDocumento = async () => {
        const entidadesDocumentoConsultadas = await entidadesDocumentoCM.consultarEntidadesDocumento(
            idEmpresa,
            idAgencia,
            idUsuario,
            estadoActivo,
            idPerfilResponsable
        );
        setEntidadesDocumento(entidadesDocumentoConsultadas);
    };

    const consultarEntidadesDocumentoEdicion = async () => {
        const entidadesDocumentoConsultadas = await entidadesDocumentoCM.consultarEntidadesDocumentoEdicion(
            idPerfilResponsable,
            documento!.BodegaOrigen!,
            idEmpresa,
            idAgencia,
            idUsuario,
            TiposProceso.SALIDA_DE_INVENTARIO,
            estadoActivo
        );
        setEntidadesDocumento(entidadesDocumentoConsultadas);
    };

    const consultarDocumento = async (documentoIdConsultar: string) => {
        if (documentoIdConsultar !== null) {
            const documentoConsultado = await salidaInventarioCM.consultarEncabezadoDocumento({
                DocumentoId: documentoIdConsultar,
            });
            setDocumento(documentoConsultado);
        }
    };

    const consultarItems = async () => {
        const itemsConsultados = await itemCM.consultarListaItemsBodega(documento!.BodegaOrigen!);
        setItems(itemsConsultados);
    };

    const alEstablecerDocumento = async () => {
        if (estado === EstadosModalSalidaInventario.CREACION) {
            if (documento!.DocumentoId) {
                establecerDocumentoId(documento!.DocumentoId);
                await consultarEtapasSiguientes();
                await consultarEntidadesDetalle();
                await consultarDetallesDocumentoBase();
                await consultarItems();
            }
        }
        if (estado === EstadosModalSalidaInventario.EDICION) {
            await consultarEtapasSiguientes();
            await consultarEntidadesDetalle();
            await consultarDetallesDocumentoBase();
            await consultarItems();
            await consultarDetalles();
            await consultarEntidadesDocumentoEdicion();
        }
        if (estado === EstadosModalSalidaInventario.VISUALIZACION) {
            await consultarEntidadesDetalle();
            await consultarDetalles();
            await consultarEntidadesDocumentoEdicion();
        }
    };

    const consultarEntidadesDetalle = async () => {
        const entidadesDetalleConsultadas = await entidadesDetalleCM.consultarEntidadesDetalle(
            documento!.BodegaOrigen!,
            documento!.TipoDocumentoId,
            idEmpresa,
            idAgencia,
            idUsuario
        );
        setEntidadesDetalle(entidadesDetalleConsultadas);
    };

    const consultarDetalles = async () => {
        const detallesConsultados = await salidaInventarioCM.consultarDetallesDocumento({ DocumentoId: documentoId! });
        setDetalles(detallesConsultados.map(mapearDetallesDocumentoBase));
    };

    const consultarEtapasSiguientes = async () => {
        const etapasSiguientesConsultadas = await salidaInventarioCM.consultarEtapas(documento!.DocumentoId);
        setEtapasSiguientes(etapasSiguientesConsultadas);
    };

    const crearDocumento = async (documentoCrear: IDocumento) => {
        const respuesta = await salidaInventarioCM.guardarEncabezado(mapearDocumentoCrear(documentoCrear));
        if (respuesta.Resultado) await consultarDocumento(respuesta.Entidades[0].DocumentoId);
    };

    const mapearDocumentoCrear = (documentoCrear: IDocumento): IDocumento => {
        return {
            ...documentoCrear,
            EmpresaId: idEmpresa,
            AgenciaId: idAgencia,
        };
    };

    const editarDocumento = async (documentoEditar: IDocumento) => {
        const respuesta = await salidaInventarioCM.editarEncabezado(documentoEditar);
        if (respuesta.Resultado) await consultarDocumento(documento!.DocumentoId);
    };

    const cambiarEtapa = async (etapaId: number) => {
        manejadorDialogoGlobal({ estado: false });
        const cambioEtapaExitoso = await salidaInventarioCM.cambiarEtapa({ ...documento!, EtapaId: etapaId });
        if (cambioEtapaExitoso) {
            await consultarDocumento(documento!.DocumentoId);
        }
    };

    const confirmarCambiarEtapa = async (etapaId: number) => {
        manejadorDialogoGlobal({
            accionCancelar: () => manejadorDialogoGlobal({ estado: false }),
            accionConfirmar: () => cambiarEtapa(etapaId),
            estado: true,
            mensaje: <Texto id={'etapas.CambioEtapa'} />,
            mostrarCancelar: true,
            tipoDialogo: 'Advertencia',
            titulo: <Texto id="titulo.advertencia" />,
        });
    };

    const editarDetalle = async (detalle: IDocumentoDetalle) => {
        const respuesta = await salidaInventarioCM.editarDetalle(detalle);
        await consultarDetallesDocumentoBase();
        await consultarDetalles();
        return respuesta;
    };
    const confirmarEliminarDetalle = async (detalle: IDocumentoDetalle) => {
        manejadorDialogoGlobal({
            accionCancelar: () => manejadorDialogoGlobal({ estado: false }),
            accionConfirmar: () => eliminarDetalle(detalle),
            estado: true,
            mensaje: <Texto id={'alerta.confirmacionEliminacion'} />,
            mostrarCancelar: true,
            tipoDialogo: 'Advertencia',
            titulo: <Texto id="titulo.advertencia" />,
        });
    };

    const eliminarDetalle = async (detalle: IDocumentoDetalle) => {
        manejadorDialogoGlobal({ estado: false });
        const respuesta = await salidaInventarioCM.eliminarDetalle(detalle);
        if (respuesta) {
            setDetalleInicialEdicion(null);
            await consultarDetallesDocumentoBase();
            await consultarDetalles();
        }
    };

    const consultarDetallesDocumentoBase = async () => {
        const detallesBase = await salidaInventarioCM.consultarDetallesDocumento({
            DocumentoId: documento!.DocumentoPredecesorId,
        });
        setDocumentoDetallesBase(detallesBase.map(mapearDetallesDocumentoBase));
    };

    const mapearDetallesDocumentoBase = (
        detalle: IDocumentoDetalleConsultaGeneral
    ): IDocumentoDetalleConsultaGeneral => {
        return {
            ...detalle,
            DivisionOrigen: detalle.DivisionOrigen ? detalle.DivisionOrigen : detalle.DivisionDestino,
            DescripcionDivisionOrigen: detalle.DivisionOrigen
                ? detalle.DescripcionDivisionOrigen
                : detalle.DescripcionDivisionDestino,
            CantidadEntregada: detalle.CantidadEntregada,
            PesoFraccionRecibido: detalle.PesoFraccionRecibido,
        };
    };

    const consultaDocumentoBase = async (codigoDocumentoBase: string) => {
        const documentoBase = await salidaInventarioCM.consultarDocumentoBase({
            CodigoDocumento: codigoDocumentoBase,
            IdAgencia: idAgencia,
        });
        if (documentoBase) {
            setDocumento(mapearDocumentoBase(documentoBase));
            consultarTipoDocumento(documentoBase!.BodegaOrigen!, 'BodegaOrigen');
        }
    };

    const mapearDocumentoBase = (documentoBase: IDocumento): IDocumentoConsultaGeneral => {
        return {
            ...DOCUMENTO_CONSULTA_GENERAL_POR_DEFECTO,
            BodegaDestino: documentoBase.BodegaDestino,
            CodigoDocumentoPredecesor: documentoBase.CodigoDocumento,
            CondicionComercial: documentoBase.CondicionComercial,
            DireccionEntrega: documentoBase.DireccionEntrega,
            DocumentoPredecesorId: documentoBase.DocumentoId,
            DocumentoRelacionado: documentoBase.DocumentoRelacionado,
            FechaEntrega: documentoBase.FechaEntrega,
            Observacion: documentoBase.Observacion,
            ProveedorId: documentoBase.ProveedorId,
            ResponsableId: documentoBase.ResponsableId,
            BodegaOrigen: documentoBase.BodegaOrigen
        };
    };

    const agregarDetalles = async (detallesAgregar: IDocumentoDetalle[]) => {
        const respuesta = await salidaInventarioCM.guardarDetalle(
            detallesAgregar.map((detalle) => ({
                ...detalle,
                DocumentoDetallePredecesorId: detalle.DocumentoDetallePredecesorId,
                DocumentoId: documento!.DocumentoId,
            }))
        );
        setEjecutarConsultarDocumentos((ejecutarConsultarDocumentosActual) => !ejecutarConsultarDocumentosActual);
        await consultarDetalles();
        return respuesta;
    };

    const consultarTipoDocumento = async (idBodega: number, nombreNodega?: string) => {
        if (nombreNodega === 'BodegaOrigen') {
            const tiposDocumentosBodega = await entidadesDocumentoCM.consultarTipoDocumento(idBodega, estadoActivo);
            setEntidadesDocumento({ ...entidadesDocumento, tiposDocumento: tiposDocumentosBodega });
        }
    };

    return (
        <Dialog open={estado !== EstadosModalSalidaInventario.CERRADO} maxWidth="lg">
            <ModalEncabezado
                cerrar={cerrar}
                titulo={
                    estado === EstadosModalSalidaInventario.CREACION ? (
                        <Texto id="ModalSalidaInventario.TituloCreacion" />
                    ) : estado === EstadosModalSalidaInventario.EDICION ? (
                        <Texto id="ModalSalidaInventario.TituloEdicion" />
                    ) : estado === EstadosModalSalidaInventario.VISUALIZACION ? (
                        <Texto id="ModalSalidaInventario.TituloVisualizacion" />
                    ) : (
                        undefined
                    )
                }
            />
            <DialogContent>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        {(!documento || !documento.DocumentoId) && (
                            <DocumentoBuscador consultaDocumentoBase={consultaDocumentoBase} />
                        )}
                    </Grid>
                    {documento && (
                        <Grid item xs={12}>
                            <FormularioDocumento
                                cambiarEtapa={confirmarCambiarEtapa}
                                camposDeshabilitar={
                                    estado === EstadosModalSalidaInventario.CREACION
                                        ? CAMPOS_DESHABILITAR_DOCUMENTO_FORMULARIO
                                        : CAMPOS_DESHABILITAR_DOCUMENTO_FORMULARIO_EDICION
                                }
                                camposOcultar={CAMPOS_OCULTAR_DOCUMENTO_FORMULARIO}
                                editarDocumento={editarDocumento}
                                estado={
                                    !documento || !documento.DocumentoId
                                        ? EstadosFormularioDocumento.CREACION
                                        : (estado === EstadosModalSalidaInventario.CREACION && documento.DocumentoId) ||
                                            estado === EstadosModalSalidaInventario.EDICION
                                            ? EstadosFormularioDocumento.EDICION
                                            : EstadosFormularioDocumento.VISUALIZACION
                                }
                                etapasSiguientes={etapasSiguientes}
                                documento={documento}
                                entidadesDocumento={entidadesDocumento}
                                guardarDocumento={crearDocumento}
                                descargarDocumentoPdf={descargarDocumentoPdf}
                                consultarTipoDocumento={consultarTipoDocumento}
                                mostrarModalEvidencia={true}
                                esTraslado={false}
                            />
                        </Grid>
                    )}
                    {documento && documento.DocumentoPredecesorId && (
                        <Grid item xs={12}>
                            <TablaDetallesPlantilla
                                agregarDetalles={agregarDetalles}
                                camposOcultar={CAMPOS_DESHABILITAR_TABLA_INVENTARIO}
                                camposEditables={['CantidadEntregada']}
                                deshabilitada={
                                    (estado === EstadosModalSalidaInventario.CREACION && !documento) ||
                                    estado === EstadosModalSalidaInventario.VISUALIZACION
                                }
                                tipoCantidad={'CantidadEntregada'}
                                detalles={DocumentoDetallesBase}
                                entidades={entidadesDetalle}
                                titulo={
                                    <Texto fontWeight="bold" id="ModalTraslados.TituloTablaDetallesDocumentoBase" />
                                }
                                seriadoConsulta={true}
                                manejaPeso={false}
                                mostrarDesplegable={true}
                                bodegaIdOrigen={documento.BodegaOrigen!}
                                alAgregarDetalles={consultarDetalles}
                            />
                        </Grid>
                    )}
                    {(!documento || !documento.DocumentoPredecesorId) && (
                        <Grid item xs={12}>
                            <DetallesInventario
                                agregarDetalles={agregarDetalles}
                                alAgregarDetalles={consultarDetalles}
                                consultarInventario={async (bodegaId: number, itemId: number) =>
                                    movimientoCM.stockItemResponsable(bodegaId, itemId, documento!.ResponsableId!)
                                }
                                deshabilitado={!documento || !documento.ListaAcciones.PermiteAgregarDetalle}
                                documento={documento}
                                items={items}
                                tipoCantidad="CantidadEntregada"
                                entidades={entidadesDetalle}
                                camposEditables={CAMPOS_EDITABLES_DETALLES_INVENTARIO}
                                camposOcultar={CAMPOS_OCULTAR_DETALLES_INVENTARIO}
                                recibeSerial={true}
                                seriadoConsulta={true}
                                esOrdenTraslado={false}
                                mostrarPesoCampoPeso={false}
                            />
                        </Grid>
                    )}
                    {estado !== EstadosModalSalidaInventario.VISUALIZACION && (
                        <Grid item xs={12}>
                            <DetallesFormulario
                                alEditarDetalle={async () => {
                                    setDetalleInicialEdicion(null);
                                    await consultarDetalles();
                                }}
                                camposDeshabilitar={CAMPOS_DESHABILITAR_DETALLES_FORMULARIO}
                                camposOcultar={CAMPOS_OCULTAR_DETALLES_FORMULARIO}
                                deshabilitado={!documento || !detalleInicialEdicion}
                                detalleInicialEdicion={detalleInicialEdicion}
                                documentoId={documento ? documento.DocumentoId : ''}
                                editarDetalle={editarDetalle}
                                entidades={entidadesDetalle}
                                estado={EstadosDetallesFormulario.EDICION}
                                tipoCantidad="CantidadEntregada"
                                seriadoConsulta={false}
                                esTraslado={false}
                                bloquearCantidadSerial={true}
                                documentoDetallesBase={DocumentoDetallesBase}
                                esEntradaInventario={false}
                                esOrdenTraslado={false}
                            />
                        </Grid>
                    )}
                    <Grid item xs={12}>
                        <TablaDetalles
                            camposOcultar={CAMPOS_OCULTAR_DETALLES_TABLA}
                            detalles={detalles}
                            editarDetalle={(detalle: IDocumentoDetalleConsultaGeneral) =>
                                setDetalleInicialEdicion(detalle)
                            }
                            editarDetalleDeshabilitado={
                                documento ? !documento.ListaAcciones.PermiteEditarDetalle : false
                            }
                            eliminarDetalle={confirmarEliminarDetalle}
                            eliminarDetalleDeshabilitado={
                                documento ? !documento.ListaAcciones.PermiteEliminarDetalle : false
                            }
                            mostrarAcciones={
                                estado === EstadosModalSalidaInventario.CREACION ||
                                estado === EstadosModalSalidaInventario.EDICION
                            }
                            recargarTabla={consultarDetalles}
                            titulo={<Texto fontWeight="bold" id="ModalSalidaInventario.TituloTablaDetalles" />}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <DocumentoValorTotal detalles={detalles} />
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    );
};

export default ModalSalidaInventario;
